import styled from "styled-components";

export const DetailContainer = styled.div`
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;

    > div {
      display: flex;
      align-items: center;
    }
  }

  .statusChip {
    margin-left: 12px;
  }

  .actionButtons {
    display: flex;
    gap: 12px;
  }

  .videoDetails {
    padding: 24px;
  }

  .editForm {
    max-width: 600px;
  }

  .infoSection {
    h6 {
      margin-bottom: 16px;
      border-bottom: 1px solid ${({ theme }) => theme.colors.border};
      padding-bottom: 8px;
    }
  }

  .infoRow {
    display: flex;
    margin-bottom: 16px;
    align-items: center;

    > :first-child {
      width: 150px;
      font-weight: 600;
    }
  }

  .previewSection {
    h6 {
      margin-bottom: 16px;
      border-bottom: 1px solid ${({ theme }) => theme.colors.border};
      padding-bottom: 8px;
    }
  }

  .videoPreview {
    position: relative;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio */

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: none;
    }
  }

  .embedButton {
    margin-top: 16px;
  }

  .loadingPreview,
  .loadingContainer,
  .errorContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    gap: 16px;
  }

  @media (max-width: 768px) {
    .header {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }

    .actionButtons {
      width: 100%;
      justify-content: flex-end;
    }
  }
`;
